import { createItemStorage } from "../../utils/createItemStorage";

export const priceItem = ({ storage }) => createItemStorage(storage, "pi_v2");
